var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(-421.494 -527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 68,
    height: 68,
    transform: "translate(421.494 527)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-email",
    "data-name": "Icon material-email",
    d: "M63.852,6H9.761a6.752,6.752,0,0,0-6.728,6.761L3,53.329a6.781,6.781,0,0,0,6.761,6.761H63.852a6.781,6.781,0,0,0,6.761-6.761V12.761A6.781,6.781,0,0,0,63.852,6Zm0,13.523-27.045,16.9L9.761,19.523V12.761l27.045,16.9,27.045-16.9Z",
    transform: "translate(418.688 527.955)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/mailLogo.a30bafb830abccdbad3216757cc221bc.svg";
export { ForwardRef as ReactComponent };